import React, { Component } from "react";
import { Base } from "zina-dogi-react";
/**
 * Base container to create download report views based on report
 * components. Use this in case new report view creation
 */
class BaseReport extends Component {
    render() {
        const { extraProps } = this.props;
        const { base_options, report_component } = this.props.extraProps
        const base_op = {
            ...base_options,
            extraProps,
            loading: false,
        };
        return (
            <Base {...base_op}>
                
                {React.createElement(report_component)}
            </Base>
        );
    }
}

export default BaseReport;
